// extracted by mini-css-extract-plugin
module.exports = {"box":"Droit_style_box__125Fr","wrap":"Droit_style_wrap__1dtom","xicon":"Droit_style_xicon__2-PlS","offimg":"Droit_style_offimg__VkO1n","onimg":"Droit_style_onimg__17pV1"};